import { produce } from 'immer';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from '../../../../../../common/widgets/Button';
import { CustomerPermissionsContext } from '../../../../contexts/CustomerPermissionsContext';
import { resources } from '../../../../resources/resources';
import FileImportTabs from './Components/FileImportTabs';
import ImportEmployeesFileForm from './Components/ImportEmployeesFileForm';
import ImportTransactionsFileForm from './Components/ImportTransactionsFileForm';
import { FileInportTabTypes } from './types';

interface FileImportState {
  currentTab: FileInportTabTypes;
}

export default function FilesImportPage() {
  const { t: translate } = useTranslation();
  const navigate = useNavigate();
  const permissions = useContext(CustomerPermissionsContext);
  const [state, setState] = useState<FileImportState>({
    currentTab: FileInportTabTypes.EmployeeFileTab,
  } as FileImportState);
  const onTabChange = (tab: FileInportTabTypes) => {
    setState(
      produce(d => {
        d.currentTab = tab;
      }),
    );
  };
  return (
    <div className="panel padding-xl uploads-panel">
      <div className="btn-panel-back-wrapper">
        <Button
          className="btn btn-panel-back"
          onClick={() => navigate('/admin/employee-management')}
        >
          <span className="btn-text">
            {translate(resources.admin.employees.details.crumbText)}
          </span>
        </Button>
      </div>
      <h1>{translate(resources.admin.fileImport.title)}</h1>
      <div>
        <FileImportTabs
          activeTab={state.currentTab}
          onTabChange={onTabChange}
        ></FileImportTabs>
      </div>
      {state.currentTab === FileInportTabTypes.EmployeeFileTab &&
        permissions.canImportEmployees && <ImportEmployeesFileForm />}
      {state.currentTab === FileInportTabTypes.TransactionFileTab &&
        permissions.canImportBudget && <ImportTransactionsFileForm />}
    </div>
  );
}
